<template>
  <div class="custom-field">
    <component
      :is="component"
      :id="String(custom.idCustomField)"
      v-model="_value"
      :label="custom.label"
      v-bind="componentProps"
    />
  </div>
</template>


<script lang="ts">
export default { name: 'OCustomField' }
</script>

<script setup lang="ts">
import DateField from '@/components/fields/Date.vue'
import { augmenters } from '@/composables/useFieldAugmenters'

import { CustomFieldDataType } from '~/_api/models/customField'

interface Props {
  modelValue?: any
  custom: Record<string, any>
}

const props = defineProps<Props>()

const emit = defineEmits<{
  (e: 'update:modelValue', value: any): void
}>()

const _value = computed({
  get() {
    return props.modelValue
  },
  set(value: any) {
    emit('update:modelValue', value)
  },
})

const component = computed(() => {
  switch (props.custom.dataType) {
    case CustomFieldDataType.date:
      return DateField
    case CustomFieldDataType.bool:
      return resolveComponent('USwitch')
    case CustomFieldDataType.number:
      return resolveComponent('UInputNumber')
    case CustomFieldDataType.longtext:
      return resolveComponent('UTextarea')
    case CustomFieldDataType.multiple:
      return resolveComponent('USelect')
    default:
      return resolveComponent('UInput')
  }
})

const componentProps = computed(() => {
  const result: Record<string, any> = {}

  if (props.custom.dataType === CustomFieldDataType.multiple) {
    result.items = props.custom.multipleValues
      .map((value: string) => ({ value, label: value }))
  }

  if (props.custom.dataType === CustomFieldDataType.date) {
    result.augmenter = augmenters.timestamp
  }

  return result
})
</script>
